module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.connected) ? _c('left-panel', {
    attrs: {
      "context": _vm.context
    }
  }) : _vm._e(), _vm._v(" "), (_vm.connected) ? _c('right-panel') : _vm._e(), _vm._v(" "), _c('f7-views', [_c('f7-view', {
    attrs: {
      "domCache": false,
      "uniqueHistory": false,
      "id": "main-view",
      "main": "",
      "url": _vm.url
    }
  }, [(_vm.connected && !_vm.isSmartphoneOS) ? _c('web-header', {
    key: 'web-header-' + _vm.webheaderKey,
    attrs: {
      "context": _vm.context
    }
  }) : _vm._e(), _vm._v(" "), (_vm.connected) ? _c('mobile-header', {
    key: 'mobile-header-' + _vm.webheaderKey,
    attrs: {
      "context": _vm.context
    }
  }) : _vm._e(), _vm._v(" "), _c('f7-pages')], 1)], 1), _vm._v(" "), _c('cm-popups'), _vm._v(" "), _c('user-guide')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65430c42", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65430c42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2439
// module chunks = 2